import { areUnitsSame } from './areUnitsSame';
import { getUnit } from './getUnit';

export default {
  areUnitsSame,
  getUnit,
};
